module.exports = __webpack_public_path__ + "img/inter-blue.f023d28c.d9466878.svg";